import React, { useEffect, useState, useRef } from "react"
import { useTranslation } from 'react-i18next'
import { Modal, Dropdown } from 'react-bootstrap'

import DeleteModal from 'pages/parts/DeleteModal'
import ReactSelect from 'pages/parts/ReactSelect'
import { httpOk, GET, POST, PUT, DELETE } from 'helpers/api'

function Index() {
	const { t } = useTranslation()

	const tbodyRef = useRef()
	const scrollRef = useRef()

	const [data, setData] = useState([])
	const [employees, setEmployees] = useState([])
	const [employeesDuplicate, setEmployeesDuplicate] = useState([])
	const [selectedItem, setSelectedItem] = useState({ 'employees': [] })
	const [showModal, setShowModal] = useState(false)
	const [modalDelete, setModalDelete] = useState(false)
	const [deleteModalParams, setDeleteModalParams] = useState({ id: 0, index: 0 })

	async function searchWithFilter() {
		var filterUrl = "/kpi-groups"
		var urlParams = ""

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) setData(response.data)
	}

	async function createUpdate() {
		var response;
		if (selectedItem.id) {
			response = await PUT('/kpi-groups', selectedItem, { loader: true })
		} else {
			response = await POST('/kpi-groups', selectedItem, { loader: true })
		}

		if (httpOk(response)) {
			searchWithFilter()
			toggleModal()
		}
	}

	function addToList() {
		var selectedItemCopy = JSON.parse(JSON.stringify(selectedItem))

		selectedItemCopy.employees.push({})
		setSelectedItem(selectedItemCopy)
	}

	async function deleteGroupUser(item = {}) {
		var selectedItemCopy = { ...selectedItem }

		var foundIndex = selectedItemCopy.employees
			.findIndex(x => (x.kpi_group_user_id === item.kpi_group_user_id))

		console.log(foundIndex)
		if (item.kpi_group_user_id) {
			const response = await DELETE(`/kpi-groups-users/${item.kpi_group_user_id}`, {}, { loader: true })
			if (httpOk(response)) {
				selectedItemCopy.employees.splice(foundIndex, 1)
				setSelectedItem(selectedItemCopy)
			}
		}

		if (!item.kpi_group_user_id) {
			selectedItemCopy.employees.splice(foundIndex, 1)
			setSelectedItem(selectedItemCopy)
		}
	}

	function toggleModal(bool = false, item = { 'employees': [] }) {
		if (!item.employees) item.employees = []

		setSelectedItem(item)
		setShowModal(bool)
	}

	async function deleteItem() {
		const response = await DELETE(`/kpi-groups/${deleteModalParams.id}`, {}, { loader: true })
		if (httpOk(response)) {
			searchWithFilter()
			setModalDelete(false)
		}
	}

	// REACTSELECT LOGIC
	function handleSelectSearch(value) {
		if (value === '+' || value === '=') return
		if (!value || value === '+' || value === '=') {
			setEmployees([...employeesDuplicate])
			return
		}
		var employeesDuplicateCopy = [...employeesDuplicate]

		var filteredItems = employeesDuplicateCopy.filter(item => item.name.toLowerCase().includes(value.toLowerCase()))
		if (filteredItems[0]) {
			filteredItems[0]['selected'] = true
		}
		setEmployees(filteredItems)
	}

	function handleSelectOption(option, index) {
		var selectedItemCopy = { ...selectedItem }

		selectedItemCopy.employees[index]['id'] = option.id
		selectedItemCopy.employees[index]['name'] = option.name
		selectedItemCopy.employees[index]['role_name'] = option.role_name

		setSelectedItem(selectedItemCopy)
	}

	function closeReactSelect() {
		setTimeout(() => {
			var employeesCopy = [...employees]
			for (let i = 0; i < employeesCopy.length; i++) {
				employeesCopy[i]['selected'] = false
			}
			if (employeesCopy[0] && employeesCopy[0]['selected'])
				employeesCopy[0]['selected'] = true
			setEmployees(employeesCopy)
		}, 100);
	}

	function handleTableKeyDown(event) {
		event.stopPropagation();
		var currentIndex = employees.findIndex(el => el.selected);
		if (currentIndex >= 0) {
			var employeesCopy = [...employees]
			employeesCopy[currentIndex].selected = false
			switch (event.key) {
				case "ArrowUp":
					if (currentIndex === 0) {
						employeesCopy[employees.length - 1].selected = true
						currentIndex = employees.length - 1
					} else {
						employeesCopy[currentIndex - 1].selected = true
					}
					scrollRef.current.scrollTop = (currentIndex * 29.6) - 59.2
					break;
				case "ArrowDown":
					if (currentIndex === employees.length - 1) {
						employeesCopy[0].selected = true
						currentIndex = 0
					} else {
						employeesCopy[currentIndex + 1].selected = true
					}
					scrollRef.current.scrollTop = (currentIndex * 29.6)
					break;
				default: break;
			}

			setEmployees(employeesCopy)
		}
	}
	// REACTSELECT LOGIC

	async function getEmployees() {
		const response = await GET('/helper/employees')
		if (httpOk(response)) {
			setEmployees(response.data)
			setEmployeesDuplicate(response.data)
		}
	}

	useEffect(() => {
		getEmployees()
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('groups')} [{data.length}]
				</h4>
				<div className="d-flex">
					<button className="btn-rounded btn btn-primary"
						onClick={() => toggleModal(true)}>
						{t('create')}
					</button>
				</div>
			</div>

			<div className="card">
				<div className="card-body">

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '20%' }}>{t('name2')}</th>
									<th style={{ 'width': '10%' }}>{t('employees')}</th>
									<th style={{ 'width': '70%' }}></th>
									<th style={{ 'minWidth': '33px' }}></th>
								</tr>
							</thead>
							<tbody>
								{data?.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{index + 1}</td>
										<td className="td-ellipsis">
											<span className="link-primary" style={{ 'cursor': 'pointer' }}
												onClick={() => toggleModal(true, item)}>{item.name}</span>
										</td>
										<td className="td-ellipsis">{item?.employees?.length}</td>
										<td></td>
										<td>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>

													<Dropdown.Menu>
														<div className="table-dropdown-item"
															onClick={() => toggleModal(true, item)}>
															<i className="uil-edit-alt"></i>
															{t('edit')}
														</div>
														<div className="table-dropdown-item text-danger"
															onClick={() => {
																setDeleteModalParams({ id: item.id, index: index });
																setModalDelete(true)
															}}>
															<i className="uil-times"></i>
															{t('delete')}
														</div>
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

				</div>
			</div>

			{/* MODAL */}
			<Modal show={showModal} animation={false} centered
				dialogClassName="update-modal-width" onHide={() => toggleModal()}>
				<Modal.Header closeButton>
					<Modal.Title>
						{!selectedItem.id ?
							<>{t('create')}</>
							:
							<>{t('edit')}</>
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form autoComplete="off">
						<div className="form-group">
							<label>{t('name2')}<span className="required-mark">*</span></label>
							<input type="text" className="form-control" name="name"
								value={selectedItem.name}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'name': e.target.value })} />
						</div>

						<div className="table-responsive" style={{ 'minHeight': '300px' }}>
							<table className="table table-bordered" style={{ 'overflow': 'unset' }} >
								<thead>
									<tr>
										<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
										<th style={{ 'width': '70%' }}>{t('employee')}</th>
										<th style={{ 'width': '30%' }}>{t('role')}</th>
										<th style={{ 'minWidth': '33px' }}></th>
									</tr>
								</thead>
								<tbody>
									{selectedItem?.employees?.map((item, index) => (
										<tr key={index}>
											<td className="text-center">{index + 1}</td>
											<td>
												<ReactSelect
													uniqueId="select"
													search={handleSelectSearch}
													value={item.name}
													index={index}
													scrollRef={scrollRef}
													options={employees}
													onClose={() => closeReactSelect()}
													selectItem={(option) => handleSelectOption(option, index)}
													onKeyUp={(e) => {
														if (e.keyCode === 40 || e.keyCode === 38) {
															handleTableKeyDown(e)
														}
													}}
													table={
														<table className="table mb-0">
															<tbody ref={tbodyRef}>
																{employees.map((selectItem, selectIndex) => (
																	<tr
																		id={selectItem.id}
																		className={`cursor ${((selectItem.selected || selectItem.id === item.element_id) && 'selected')}`}
																		tabIndex={-1}
																		key={selectIndex}
																		onClick={() => handleSelectOption(selectItem, index)}
																		onKeyDown={(e) => handleTableKeyDown(e, selectItem, index)}>
																		<td>{selectItem.name}</td>
																		<td className="text-end">{selectItem.role_name}</td>
																	</tr>
																))}
															</tbody>
														</table>
													}
												/>
											</td>
											<td>{item.role_name}</td>
											<td>
												<td className="vertical-middle">
													<div className="d-flex justify-content-center">
														<div className="table-action-button table-action-danger-button"
															onClick={() => deleteGroupUser(item)}>
															<i className="uil uil-times"></i>
														</div>
													</div>
												</td>
											</td>
										</tr>
									))}
									<tr>
										<td colSpan={2} style={{ 'padding': 0 }}>
											<div className="d-flex">
												<div className="w-100">
													<button type="button" className="btn-sm btn-primary w-100"
														onClick={() => addToList(1)}>
														{t('add')}
													</button>
												</div>
											</div>
										</td>
										<td></td>
										<td></td>
									</tr>
								</tbody>
							</table>
						</div>

						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModal()}>
								{t('cancel')}
							</button>
							<button type="button" className="btn btn-primary w-100"
								onClick={() => createUpdate()}>
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL */}

			<DeleteModal
				modalDelete={modalDelete}
				setModalDelete={setModalDelete}
				deleteItem={deleteItem}>
			</DeleteModal>
		</>
	)
}

export default Index